import { render, staticRenderFns } from "./GLMaster.vue?vue&type=template&id=5152d9b7&scoped=true&"
import script from "./GLMaster.vue?vue&type=script&lang=js&"
export * from "./GLMaster.vue?vue&type=script&lang=js&"
import style0 from "./GLMaster.vue?vue&type=style&index=0&id=5152d9b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5152d9b7",
  null
  
)

export default component.exports